var render = function (_h,_vm) {var _c=_vm._c;return _c('span',_vm._g({class:['Icon', _vm.data.class, _vm.data.staticClass]},_vm.listeners),[_c('i',{class:("i-" + (_vm.props.name))}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }